import React from "react";
import OnBoadingSelectIndustryStyles from "./OnBoadingSelectIndustry.styles";
import {
  Autocomplete,
  Box,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import BrandLogo from "../../../../assets/icons/logo-icon.svg";
import onboadingImg from "../../../../assets/images/select-industry.svg";
import CustomButton from "../../../../global/components/CustomButton/CustomButton";
import history from "../../../../utils/history";
import urls from "../../../../global/constants/UrlConstants";

const options = ["Option 1", "Option 2"];

const OnBoadingSelectIndustry = () => {
  const classes = OnBoadingSelectIndustryStyles;
  const [value, setValue] = React.useState<string | null>(options[0]);
  const [inputValue, setInputValue] = React.useState("");

  const handleGetStart = () => {
    history.push({
      pathname: urls.dashboardViewPath,
      state: { fromPage: "OnBoadingSelectIndustry" },
    });
  };

  const handleSelectChange = () => {};

  const getOnBoadingSelectIndustry = () => {
    return (
      <>
        <Box sx={classes.onBoadingSelectIndustryWrapper}>
          <Grid container>
            <Grid item xs={10} mx={"auto"}>
              <Grid container>
                <Grid item xs={5}>
                  <Box sx={classes.leftSection}>
                    <Box>
                      <img src={BrandLogo} alt="logo-img" />
                    </Box>

                    <Box>
                      <Typography sx={classes.onboadingHeading}>
                        Welcome! Amit Jain
                      </Typography>
                      <Typography sx={classes.onBoadingtext}>
                        You are a step closer to driving smarter and more <br />{" "}
                        powerful CRM product
                      </Typography>
                    </Box>

                    <Box>
                      <Autocomplete
                        value={value}
                        onChange={(event: any, newValue: string | null) => {
                          setValue(newValue);
                        }}
                        inputValue={inputValue}
                        onInputChange={(event, newInputValue) => {
                          setInputValue(newInputValue);
                        }}
                        id="controllable-states-demo"
                        options={options}
                        sx={{ width: 300 }}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </Box>

                    <Box>
                      <CustomButton
                        label="Get Started"
                        buttonType="primaryBtn"
                        onClick={() => {
                          handleGetStart();
                        }}
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={7}>
                  <Box sx={classes.rightSection}>
                    <img src={onboadingImg} alt="img" />
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </>
    );
  };

  return getOnBoadingSelectIndustry();
};

export default OnBoadingSelectIndustry;
